import type { SVGProps } from 'react';
const SvgIconOrders = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M6.5 6A.75.75 0 1 1 5 6a.75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.5 6a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 7.5 6m.75 2.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 12a1.5 1.5 0 0 1-.44 1.062l-1.503 1.5a1.5 1.5 0 0 1-2.121-.002l-.437-.438-.438.439a1.5 1.5 0 0 1-2.12 0l-.442-.44-.437.439a1.5 1.5 0 0 1-2.123 0l-1.5-1.5A1.5 1.5 0 0 1 2 12V3.5A2.5 2.5 0 0 1 4.5 1h7A2.5 2.5 0 0 1 14 3.5zM3.5 12V3.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1V12l-1.503 1.5-1.143-1.146a.5.5 0 0 0-.708 0L8 13.5l-1.149-1.147a.5.5 0 0 0-.707 0L5 13.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconOrders;
